import { request } from '../axios/request';

import {
  FETCH_PERMISSIONS_PENDING,
  FETCH_PERMISSIONS_REJECTED,
  FETCH_PERMISSIONS_FULFILLED,
} from '../constants/permissions';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PERMISSIONS_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_PERMISSIONS_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_PERMISSIONS_REJECTED,
  error,
});

export const fetchPermissions = (staffId) => async (dispatch) => {
  try {
    dispatch(pending());
    const url = $U.STAFF_PERMISSIONS.replace('{0}', staffId);
    const { data } = await request({ url, method: 'get' });
    dispatch(fulfilled(data));
  } catch (e) {
    dispatch(rejected(e));
  }
};



// WEBPACK FOOTER //
// ./src/actions/permissions.js